module.exports = __webpack_public_path__ + "img/logo_font2@2x.17890fa9.png";